import type { RouteLocationNormalizedLoaded } from "vue-router";

type PageKeyRoute = Pick<
    RouteLocationNormalizedLoaded,
    "name" | "params" | "path" | "fullPath"
>;

/**
 * Key for the application page wrapper. It drives both component recreation and
 * the page-enter transition, so by default it is the full path (every page is a
 * fresh instance).
 *
 * Element pages (task/gateway/event/flow) are the exception: selecting a
 * different element is sub-navigation *within* a process workspace, not a new
 * page. Keying those on the element id tore the page down and rebuilt it on
 * every selection — re-importing the BPMN diagram and flashing the viewport.
 * Stripping the element segment gives all elements of a workspace a stable key,
 * so element->element reuses the page + diagram; the singleton entity stores
 * react to the selected element (and reload the diagram only when the parent
 * process actually changes).
 */
export function pageKeyForRoute(route: PageKeyRoute): string {
    if (route.name === "processElementPage") {
        const elementType = route.params.elementType;
        if (typeof elementType === "string" && elementType) {
            const marker = `/${elementType}/`;
            const idx = route.path.lastIndexOf(marker);
            if (idx !== -1) {
                return `${route.path.slice(0, idx)}/__process_element__`;
            }
        }
    }
    return route.fullPath;
}
